/* ===================================================================
   PRODUCT PAGE — buy box behavior. Vanilla JS, real Shopify AJAX Cart API.

   v1.1 — DOUBLE-BINDING FIX
   This file is included by BOTH sections/main-product.liquid and
   sections/product-faq.liquid. Two <script> tags with the same src both
   execute, so every listener was being attached twice:

     · "Read more" toggled `is-clamped` on, then straight back off,
       so the description never expanded — the reported bug.
     · The quantity stepper jumped by 2 on every click.
     · Add to cart fired two POSTs to /cart/add.js, adding double the
       intended quantity.

   Fixed with two guards rather than by deleting an include, so the FAQ
   section stays self-sufficient if it's ever used on its own page, and
   any section added later can include this file safely:

     1. A module-level guard, so the second execution is a no-op.
     2. A per-element guard on the buy box, so re-running boot() (which
        the theme editor does on shopify:section:load) can't stack
        handlers either.
   =================================================================== */
(function () {
  'use strict';

  /* Guard 1 — only the first copy of this script on the page does anything. */
  if (window.__wbProductPageLoaded) return;
  window.__wbProductPageLoaded = true;

  function moneyFormat(cents, format) {
    if (window.Shopify && Shopify.formatMoney) {
      try { return Shopify.formatMoney(cents, format); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function showToast(msg, iconId) {
    var stack = document.getElementById('toastStack');
    if (!stack) return;
    var t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = '<svg class="icon"><use href="#' + (iconId || 'i-check') + '"></use></svg><span>' + msg + '</span>';
    stack.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () { t.remove(); }, 400);
    }, 2800);
  }

  function fetchCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function refreshHeaderCartCount(cart) {
    var el = document.getElementById('cartCount');
    if (el && cart) {
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      el.textContent = cart.item_count;
    }
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cartDrawer');
    if (drawer) drawer.classList.add('is-open');
  }
  function closeCartDrawer() {
    var drawer = document.getElementById('cartDrawer');
    if (drawer) drawer.classList.remove('is-open');
  }

  function renderCartDrawer(cart) {
    var cartBody = document.getElementById('cartBody');
    var cartFoot = document.getElementById('cartFoot');
    var cartSubtotal = document.getElementById('cartSubtotal');
    if (!cartBody || !cartFoot) return;
    if (!cart || cart.item_count === 0) {
      cartBody.innerHTML = '<div class="cart-empty"><svg class="icon" style="width:40px;height:40px;"><use href="#i-cart"></use></svg><p>Your cart is empty.</p></div>';
      cartFoot.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      html += '' +
        '<div class="cart-line" data-key="' + item.key + '">' +
          '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
          '<div class="cart-line-info">' +
            '<div><span class="name">' + item.product_title + '</span><div class="variant">' + (item.variant_title || 'Default') + '</div></div>' +
            '<div class="cart-line-bottom"><span style="font-size:0.85rem;">Qty ' + item.quantity + '</span><span style="font-weight:700;">' + moneyFormat(item.final_line_price) + '</span></div>' +
          '</div>' +
        '</div>';
    });
    cartBody.innerHTML = html;
    cartFoot.style.display = 'block';
    if (cartSubtotal) cartSubtotal.textContent = moneyFormat(cart.total_price);
  }
  window.__lunerenderCart = renderCartDrawer;

  function initCartDrawer() {
    var toggle = document.getElementById('cartToggle');
    var drawer = document.getElementById('cartDrawer');
    if (toggle && drawer && !toggle.dataset.wbBound) {
      toggle.dataset.wbBound = '1';
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(renderCartDrawer);
        openCartDrawer();
      });
      drawer.querySelectorAll('[data-close-cart]').forEach(function (el) {
        el.addEventListener('click', closeCartDrawer);
      });
    }
    var checkoutBtn = document.getElementById('checkoutBtn');
    if (checkoutBtn && !checkoutBtn.dataset.wbBound) {
      checkoutBtn.dataset.wbBound = '1';
      checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });
    }
  }

  function addToCart(variantId, quantity, btn) {
    if (!variantId) {
      showToast('Please select a variant', 'i-shield');
      return;
    }
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        refreshHeaderCartCount(cart);
        openCartDrawer();
        if (window.__lunerenderCart) window.__lunerenderCart(cart);
        showToast('Added to cart', 'i-check');
      })
      .catch(function () { showToast('Could not add this item to your cart', 'i-shield'); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  function initBuyBox(root) {
    /* Guard 2 — never wire the same buy box twice. */
    if (root.dataset.wbBound) return;

    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    root.dataset.wbBound = '1';

    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var variantIdInput = root.querySelector('[data-variant-id-input]');
    var priceEl = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var saveEl = root.querySelector('[data-save-badge]');
    var availabilityEl = root.querySelector('[data-availability]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var currentValueEls = Array.prototype.slice.call(root.querySelectorAll('[data-current-value]'));

    function getSelectedOptions() {
      var selections = [];
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        groups[idx] = input.value;
      });
      var max = product.options ? product.options.length : 0;
      for (var i = 0; i < max; i++) selections.push(groups[i]);
      return selections;
    }

    function findVariant(selections) {
      return product.variants.filter(function (v) {
        return v.options.every(function (val, i) { return selections[i] === undefined || val === selections[i]; });
      })[0];
    }

    function updateSwatchStates() {
      // disable combinations that don't exist
      optionInputs.forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var testSelections = getSelectedOptions();
        testSelections[idx] = input.value;
        var match = findVariant(testSelections);
        var label = input.closest('.pb-swatch');
        if (label) label.classList.toggle('is-disabled', !match || !match.available);
      });
    }

    function render(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = moneyFormat(variant.compare_at_price);
          comparePriceEl.style.display = '';
          if (saveEl) {
            var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            saveEl.textContent = 'Save ' + pct + '%';
            saveEl.style.display = '';
          }
        } else {
          comparePriceEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      if (availabilityEl) {
        availabilityEl.classList.toggle('is-oos', !variant.available);
        var availText = availabilityEl.querySelector('[data-availability-text]');
        if (availText) {
          availText.textContent = variant.available
            ? (availabilityEl.getAttribute('data-in-stock-label') || 'In stock, ready to ship')
            : (availabilityEl.getAttribute('data-oos-label') || 'Currently sold out');
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        var addLabel = addBtn.querySelector('[data-add-to-cart-label]');
        if (addLabel) {
          addLabel.textContent = variant.available
            ? addBtn.getAttribute('data-label-available')
            : addBtn.getAttribute('data-label-sold-out');
        }
      }
      currentValueEls.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-current-value'), 10);
        el.textContent = variant.options[idx] || '';
      });
      // sync sticky ATC mirror
      document.dispatchEvent(new CustomEvent('lune:variant-change', { detail: { variant: variant, product: product } }));
      updateSwatchStates();
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var group = root.querySelectorAll('[data-option-index="' + input.getAttribute('data-option-index') + '"]');
        group.forEach(function (el) {
          var lbl = el.closest('.pb-swatch');
          if (lbl) lbl.classList.toggle('is-selected', el.checked || el.value === input.value);
        });
        var selections = getSelectedOptions();
        var variant = findVariant(selections);
        if (variant) render(variant);
      });
    });

    /* quantity stepper */
    var qty = 1;
    var qtyVal = root.querySelector('[data-qty-value]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    function renderQty() {
      if (qtyVal) qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    }
    if (qtyPlus) qtyPlus.addEventListener('click', function () { qty = Math.min(qty + 1, 99); renderQty(); });
    if (qtyMinus) qtyMinus.addEventListener('click', function () { qty = Math.max(qty - 1, 1); renderQty(); });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addToCart(variantIdInput ? variantIdInput.value : null, qty, addBtn);
      });
    }

    /* description expand/collapse */
    var descToggle = root.querySelector('[data-desc-toggle]');
    var descEl = root.querySelector('[data-desc]');
    if (descToggle && descEl) {
      descToggle.addEventListener('click', function () {
        var collapsed = descEl.classList.toggle('is-clamped');
        descToggle.textContent = collapsed
          ? (descToggle.getAttribute('data-label-more') || 'Read more')
          : (descToggle.getAttribute('data-label-less') || 'Read less');
        descToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
      descToggle.setAttribute('aria-expanded', descEl.classList.contains('is-clamped') ? 'false' : 'true');
    }

    /* init with the server-rendered variant (matches what Liquid already
       printed, so there's no flash of the wrong price/variant on load) */
    var initialId = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
    var initial = product.variants.filter(function (v) { return v.id === initialId; })[0] || product.variants[0];
    render(initial);
  }

  /* ---- accordion (drives both the buy-box accordion and the FAQ section) ---- */
  function initAccordions() {
    document.querySelectorAll('.acc-item, .faq-item').forEach(function (item) {
      var q = item.querySelector('.acc-q, .faq-q');
      var a = item.querySelector('.acc-a, .faq-a');
      if (!q || !a || q.dataset.bound) return;
      q.dataset.bound = '1';
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        a.style.maxHeight = isOpen ? null : a.scrollHeight + 'px';
      });
    });
  }

  /* ---- sticky add-to-cart bar ---- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var sentinel = document.querySelector('[data-sticky-atc-sentinel]');
    if (!bar || bar.dataset.wbBound) return;
    bar.dataset.wbBound = '1';
    var priceEl = bar.querySelector('[data-sticky-price]');
    var addBtn = bar.querySelector('[data-sticky-add]');
    var mainVariantInput = document.querySelector('[data-variant-id-input]');
    var currentVariant = null;

    document.addEventListener('lune:variant-change', function (e) {
      currentVariant = e.detail.variant;
      if (priceEl) priceEl.textContent = moneyFormat(currentVariant.price);
      if (addBtn) addBtn.disabled = !currentVariant.available;
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = currentVariant ? currentVariant.id : (mainVariantInput ? mainVariantInput.value : null);
        addToCart(id, 1, addBtn);
      });
    }

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(sentinel);
    }
  }

  /* ---- announcement bar ---- */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar || bar.dataset.wbBound) return;
    bar.dataset.wbBound = '1';
    var closeBtn = bar.querySelector('.announce-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.add('is-hidden');
        try { sessionStorage.setItem('lune_announce_dismissed', '1'); } catch (e) {}
      });
    }
    try {
      if (sessionStorage.getItem('lune_announce_dismissed') === '1') bar.classList.add('is-hidden');
    } catch (e) {}
  }

  /* ---- scroll reveal (shared pattern, safe to re-run) ---- */
  function initReveal() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.reveal:not(.is-visible)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    document.querySelectorAll('[data-buy-box]').forEach(initBuyBox);
    initAccordions();
    initStickyAtc();
    initAnnouncementBar();
    initCartDrawer();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor re-renders sections without a page reload; re-run the
     idempotent wiring so a freshly injected section still works. */
  document.addEventListener('shopify:section:load', boot);
})();
